import React from 'react'

const Footer = () => {
  return (
    <div id='Footer-wrapper'>
        <hr/>
        <h1>Copyright Gencode</h1>
        
        </div>
  )
}

export default Footer